
/**
 * 自定义错误上报;
 * @param type 自定义类型（1-error,2-warn,3-info）
 * @param code 自定义标示代码，可以是任意字符串，用于查询。最大长度128，超过将截取
 * @param msg 传入对象。最大长度1024，超过将截取
 */
export default (code = '', msg={}, type = 3) => {
  try {
    const data = {type,code,msg}
    window.__sgm__?.custom(data)
  } catch (e) {
    console.log(e)
  }
}

